const input = document.getElementById("delivery-postcode");
const errorMsg = document.getElementById("postcode-error");
const checkBtn = document.getElementById("check-delivery-btn");
const result = document.getElementById("delivery-check-result");

// Enable button when input has 4 digits
input.addEventListener("input", () => {
    const value = input.value.trim();
    errorMsg.textContent = '';
    // result.textContent = '';
    result.style.display = "none";
    
    // Validate input contains only digits
    if (value.length > 0 && !/^\d+$/.test(value)) {
        errorMsg.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg> Postcode must contain only numbers`;
        checkBtn.disabled = true;
        return;
    }
    
    // Enable button only when we have exactly 4 digits
    checkBtn.disabled = value.length !== 4;
});

// Allow only numeric input
input.addEventListener("keydown", (e) => {
    // Allow: backspace, delete, tab, escape, enter
    if ([46, 8, 9, 27, 13].includes(e.keyCode) || 
        // Allow: Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X
        (e.keyCode === 65 && e.ctrlKey === true) || 
        (e.keyCode === 67 && e.ctrlKey === true) || 
        (e.keyCode === 86 && e.ctrlKey === true) || 
        (e.keyCode === 88 && e.ctrlKey === true) ||
        // Allow: home, end, left, right
        (e.keyCode >= 35 && e.keyCode <= 39)) {
        return;
    }
    
    // Prevent if not a number
    if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
        e.preventDefault();
    }
});

checkBtn.addEventListener("click", () => {
    const postalCode = input.value.trim();
    // Validate postcode format (exactly 4 digits)
    if (!/^\d{4}$/.test(postalCode)) {
        errorMsg.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></circle></svg> Please enter a valid 4-digit postcode`;
        return;
    }
    errorMsg.textContent = '';
    result.innerHTML = '<div class="loading-spinner"></div> Checking availability...';
    checkBtn.disabled = true;

    const productName = document.querySelector('h1.title')?.innerText;
    const priceText = document.querySelector('.current-price')?.innerText || "";
    const productPrice = Math.round(parseFloat(priceText.replace(/[^0-9.]/g, "")) * 100);
    const productQuantity = document.querySelector('input[name="quantity"]')?.value;
    // console.log("Title:", productName);
    // console.log("Price:", productPrice);
    // console.log("Quantity:", productQuantity);

    fetch("https://shipping-app.logbase.io/api/shipping/rates", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "authorization": "Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJTaGlweCIsImlhdCI6MTc1Mzg3MzY3MywiZXhwIjoxNzg4MDg4MDczLCJhdWQiOiJQZXJhIEx1Z2dhZ2UiLCJzdWIiOiIifQ.dn6FChUdwb4VT0yifOgatmAvcxaTLNhRN_Ku-_tLNTo",
            "shopifydomain": "pera-luggage.myshopify.com",
        },
        body: JSON.stringify({
            rate: {
                destination: {
                    country: "AU",
                    postal_code: postalCode
                },
                items: [
                    {
                        name: productName,
                        quantity: productQuantity,
                        price: productPrice
                    }
                ]
            }
        })
    })
    .then(response => {
        if (!response.ok) {
            throw new Error(`API returned ${response.status}`);
        }
        return response.json();
    })
    .then(data => {
        if (data && data.rates && data.rates.length > 0) {
            const rate = data.rates[0];
            result.style.display = "block";
            result.innerHTML = `
                <div class="success-message">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                        <polyline points="22 4 12 14.01 9 11.01"></polyline>
                    </svg>
                    Delivery is available to ${postalCode}!
                </div>
                <div class="shipping-details">
                    <h4>Shipping Option</h4>
                    <p><strong>Service:</strong> ${rate.service_name}</p>
                    <p><strong>Shipping Rate:</strong> $${(rate.total_price / 100).toFixed(2)} ${rate.currency}</p>
                </div>
            `;
        } else {
            result.style.display = "none";
            errorMsg.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="15" y1="9" x2="9" y2="15"></line><line x1="9" y1="9" x2="15" y2="15"></line></svg> Sorry, we don't deliver to this postcode yet.`;
            result.innerHTML = '';
        }
    })
    .catch(error => {
        console.error("ShipX API error:", error);
        result.style.display = "none";
        errorMsg.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="15" y1="9" x2="9" y2="15"></line><line x1="9" y1="9" x2="15" y2="15"></line></svg> Unable to check delivery. Please try again later.`;
        result.innerHTML = '';
    })
    .finally(() => {
        checkBtn.disabled = input.value.trim().length !== 4;
    });
});